import { ZAttribute } from "src/types/ZAttribute";
import { ZAttrLabelTreeData } from "./types/ZAttrLabelTreeData";
import { makeAttrLabel, MakeLabelMode } from "./makeAttrLabel";

export const makeLabels4Leaves = (
  leaves: ZAttrLabelTreeData[],
  attributes: ZAttribute[],
  typesMap: Record<string, string>,
  mode?: MakeLabelMode,
) => {
  const attrsMap = new Map(attributes.map((attr) => [attr.id, attr]));
  const labels = leaves
    .map((leaf) => {
      const attr = attrsMap.get(leaf.attrId);
      if (!attr) return null;
      return makeAttrLabel({
        attribute: attr,
        attributeList: attributes,
        labelTreeData: [leaf],
        typesMap,
        mode,
      });
    })
    .filter((e) => !!e);
  return labels;
};
